<div class="success-container">
  <h1>Success</h1>
  <h3>Agreements accepted successfully</h3>
  <p>Your facility is now ready to be activated.</p>
  <button mat-raised-button color="primary" routerLink="/admin/facility-management">
    Go to Facility Management
  </button>
</div>
